import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import i18n from '../i18n'
import { SupportedLanguage } from '../i18n'

interface LanguageStore {
  currentLanguage: SupportedLanguage
  isLoading: boolean
  changeLanguage: (language: SupportedLanguage) => Promise<void>
  initializeLanguage: () => void
}

export const useLanguageStore = create<LanguageStore>()(
  persist(
    (set, get) => ({
      currentLanguage: 'ko',
      isLoading: false,

      changeLanguage: async (language: SupportedLanguage) => {
        try {
          set({ isLoading: true })
          await i18n.changeLanguage(language)
          set({ currentLanguage: language, isLoading: false })
        } catch (error) {
          console.error('Failed to change language:', error)
          set({ isLoading: false })
        }
      },

      initializeLanguage: () => {
        const currentLang = i18n.language as SupportedLanguage
        if (currentLang !== get().currentLanguage) {
          set({ currentLanguage: currentLang })
        }
      },
    }),
    {
      name: 'fastcut-language-store',
      partialize: (state) => ({ currentLanguage: state.currentLanguage }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.initializeLanguage()
        }
      },
    }
  )
)